<template>
  <RuleCommon :isTitle="true">
    <p>
      {{ $t('1、分享给好友：') }}
    </p>
    <p>{{ $t('若好友为新用户，注册后邀请者可获得最高188金币奖励；') }}</p>
    <p>
      {{
        $t(
          '若好友为老用户(已注册过)，但已超过15天没有打开使用，若好友再次打开使用，并成功充值金币，充值后邀请者可获得最高168金币奖励'
        )
      }}
    </p>
    <p>
      {{ $t('2、每成功邀请1名好友注册，可获得最高188金币奖励。') }}
    </p>
    <p>
      {{ $t('3、每成功邀请1名老用户并成功充值，可获得最高168金币奖励。') }}
    </p>
    <p>
      {{ $t('4、奖励金币自动到账。') }}
    </p>
    <p>
      {{ $t('5、注意事项：') }}
    </p>
    <p>
      {{
        $t(
          '*活动期间的中止、停止及续展由平台自行决定，活动停止后，新的邀请将不再享有邀请奖励'
        )
      }}
    </p>
    <p>
      {{
        $t(
          '*若邀请方存在欺诈行为，如通过买卖手机号、个人信息等方式邀请，通过非法渠道和方法、脚本等方式获取邀请奖励，平台有权按照无效邀请处理的同时，违规方将遭到平台封禁处罚'
        )
      }}
    </p>
    <p>
      {{
        $t(
          ' *请认真阅读并理解本规则，若您参与本次活动，均视为您已阅读并同意本规则，若您关于本活动有任何疑问，请您联系平台客服咨询。'
        )
      }}
    </p>
  </RuleCommon>
</template>

<script>
import RuleCommon from './RuleCommon.vue'
export default {
  components: {
    RuleCommon
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar__left img {
  width: 30px;
  height: 30px;
}
.chat-rule {
  padding: 16px 14px 0;
  font-size: 14px;
  color: rgba(51, 51, 51, 0.8);
  line-height: 17px;
  .chat-rule-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 500;
    color: #333333;
    line-height: 19px;
    .icon {
      display: inline-block;
      width: 4px;
      height: 16px;
      background: #fd4879;
      margin-right: 3px;
    }
  }
  p {
    margin-top: 8px;
  }
}
</style>
